/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SubscriptionSnapshot interface.
 */
export function instanceOfSubscriptionSnapshot(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('tier' in value) || value['tier'] === undefined)
        return false;
    return true;
}
export function SubscriptionSnapshotFromJSON(json) {
    return SubscriptionSnapshotFromJSONTyped(json, false);
}
export function SubscriptionSnapshotFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPeriodEnd': json['current_period_end'] == null ? undefined : json['current_period_end'],
        'status': json['status'],
        'stripeSubscriptionId': json['stripe_subscription_id'] == null ? undefined : json['stripe_subscription_id'],
        'tier': json['tier'],
    };
}
export function SubscriptionSnapshotToJSON(json) {
    return SubscriptionSnapshotToJSONTyped(json, false);
}
export function SubscriptionSnapshotToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'current_period_end': value['currentPeriodEnd'],
        'status': value['status'],
        'stripe_subscription_id': value['stripeSubscriptionId'],
        'tier': value['tier'],
    };
}
